import React, { useEffect } from 'react';
import RefundPolicy from './RefundPolicy';

const TracsessUserRefund: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <RefundPolicy
      appName="Tracsess"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/tracsess-user/Tracsess_Refund_Policy.pdf"
      title="Tracsess - Refund Policy"
    />
  );
};

export default TracsessUserRefund; 